var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.333 26.556c6-.681 10.667-5.902 10.667-12.24C32 7.514 26.627 2 20 2c-5.224 0-9.666 3.428-11.314 8.21H8c-4.418 0-8 3.676-8 8.211 0 4.534 3.582 8.21 8 8.21h5.333v-2.737H8a5.204 5.204 0 0 1-2.076-.43c-1.914-.831-3.257-2.776-3.257-5.043 0-3.023 2.388-5.474 5.333-5.474h2.766c.647-4.64 4.533-8.21 9.234-8.21 5.155 0 9.333 4.288 9.333 9.579 0 4.825-3.477 8.817-8 9.481v2.759zm.943-9.102c.52.534.52 1.4 0 1.935a1.309 1.309 0 0 1-1.885 0l-1.724-1.77v9.013c0 .755-.597 1.368-1.334 1.368-.736 0-1.333-.613-1.333-1.368V17.62l-1.724 1.769a1.31 1.31 0 0 1-1.885 0c-.521-.534-.521-1.4 0-1.935l4-4.105c.25-.257.589-.401.942-.401.354 0 .693.144.943.4l4 4.106z",
    fill: "#8A8DAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i523jvwsja",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 32,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.333 26.556c6-.681 10.667-5.902 10.667-12.24C32 7.514 26.627 2 20 2c-5.224 0-9.666 3.428-11.314 8.21H8c-4.418 0-8 3.676-8 8.211 0 4.534 3.582 8.21 8 8.21h5.333v-2.737H8a5.204 5.204 0 0 1-2.076-.43c-1.914-.831-3.257-2.776-3.257-5.043 0-3.023 2.388-5.474 5.333-5.474h2.766c.647-4.64 4.533-8.21 9.234-8.21 5.155 0 9.333 4.288 9.333 9.579 0 4.825-3.477 8.817-8 9.481v2.759zm.943-9.102c.52.534.52 1.4 0 1.935a1.309 1.309 0 0 1-1.885 0l-1.724-1.77v9.013c0 .755-.597 1.368-1.334 1.368-.736 0-1.333-.613-1.333-1.368V17.62l-1.724 1.769a1.31 1.31 0 0 1-1.885 0c-.521-.534-.521-1.4 0-1.935l4-4.105c.25-.257.589-.401.942-.401.354 0 .693.144.943.4l4 4.106z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload2);
export default __webpack_public_path__ + "static/media/cloud-upload2.10b4a05b9ae8a9d9b3925af6ed9b6443.svg";
export { ForwardRef as ReactComponent };